import dayjs from 'dayjs';

import { PlanInterval } from '@app/features/subscription/types/PlanInterval';

export function getPlanInterval(plan: {
  suppliedResetCount: number;
  resetPeriod: { value: number };
}): number {
  return plan.suppliedResetCount * plan.resetPeriod.value;
}

export function getPlanIntervalString(plan: {
  suppliedResetCount: number;
  resetPeriod: { value: number };
}) {
  const planInterval = getPlanInterval(plan);

  if (planInterval > 0) {
    switch (planInterval) {
      case PlanInterval.MONTH:
        return '월';
      case PlanInterval.YEAR:
        return '연';
      case PlanInterval.TWO_YEARS:
        return '2년';
      case PlanInterval.THREE_YEARS:
        return '3년';
      default:
        return `${planInterval}개월`;
    }
  }
  return null;
}

export function getNextPlanPaymentIntervalString(nextPlan: {
  suppliedResetCount: number;
  resetPeriod: { value: number };
}) {
  const interval = getPlanInterval(nextPlan);
  const now = dayjs();
  const [month, date] = [now.format('M'), now.format('D').replace('31', '말')];
  switch (interval) {
    case PlanInterval.MONTH:
      return `매달 ${date}일에 결제됩니다.`;
    case PlanInterval.YEAR:
      return `매년 ${month}월 ${date}일에 결제됩니다.`;
    case PlanInterval.TWO_YEARS:
      return `매 2년 마다 ${month}월 ${date}일에 결제됩니다.`;
    case PlanInterval.THREE_YEARS:
      return `매 3년 마다 ${month}월 ${date}일에 결제됩니다.`;
    default:
      return `${interval}개월 마다 ${date}일에 결제됩니다.`;
  }
}

export function getPlanIntervalQuery(interval: PlanInterval) {
  switch (interval) {
    case PlanInterval.MONTH:
      return 'month';
    case PlanInterval.YEAR:
      return 'year';
    case PlanInterval.TWO_YEARS:
      return 'two-years';
    case PlanInterval.THREE_YEARS:
      return 'three-years';
    default:
      throw new Error('Unsupported interval.');
  }
}
